/* eslint-disable react-hooks/exhaustive-deps */
import { useLang } from '@/i18n';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTab from '@elem/ui/ef-tab';
import EFDrone from 'elem/ui-assets/icons/appliances/EFDrone';
import { FC, useMemo, useState } from 'react';
import css from './index.module.scss';

const TheComp: FC = () => {
    const { t } = useLang('delta3Plus.AU4');
    const { pageStatus } = useDP3Store();

    const items = [
        {
            title: '4WD',
            type: '4WD',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736749405936/4WD.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736843359312/car.jpg',
            list: [
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736736441417/camera.png', title: 'Camera', w: '16W', t: '60 times' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839664311/phone.png', title: 'Phone', w: '11W', t: '89 times' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839665025/car_frige.png', title: 'Car Fridge', w: '60W', t: '16 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839664131/audio.png', title: 'Speaker', w: '10W', t: '58 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839664672/laptop.png', title: 'Laptop', w: '70W', t: '16 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839664848/fan.png', title: 'Fan', w: '40W', t: '17 hr' },
                { icon: <EFDrone />, title: 'Drone', w: '40Wh', t: '25 times' },
            ],
            info: {
                h: '5 Hr',
                list: [
                    { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839664311/phone.png', title: 'Phone', w: '11W' },
                    { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839664848/fan.png', title: 'Fan', w: '40W' },
                    { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839665261/TV.png', title: 'Laptop', w: '70W' },
                    { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839664495/light.png', title: 'LED Light', w: '10W' },
                    { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847024329/car_frige.png', title: 'Car Fridge', w: '60W' },
                ],
            },
        },
        {
            title: 'DIY',
            type: 'DIY',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737426990166/DIY.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737426989923/diy-m.jpg',
            list: [
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847023499/drill.png', title: 'Electric grill', w: '1080W', t: '0.7 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847022905/ps5.png', title: 'PS5', w: '200W', t: '4.6 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847022666/router.png', title: 'WIFI Router', w: '10W', t: '58 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847022493/angle_grinder.png', title: 'Cutting Machine', w: '1100W', t: '0.7 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847023337/electric_hammer.png', title: 'Electric Hammer', w: '1260W', t: '0.6 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847023943/circular_saw.png', title: 'Circular Saw', w: '1400W', t: '0.6 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847024329/car_frige.png', title: 'Car Fridge', w: '60W', t: '16 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847023143/microwave.png', title: 'Microwave', w: '1300W', t: '0.6 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847023743/coffee_machine.png', title: 'Coffee Maker', w: '1000W', t: '0.8 hr' },
            ],
        },
        {
            title: 'Home',
            type: 'Home',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736749405046/HOME.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736843001210/home.jpg',
            list: [
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847375209/router.png', title: 'WIFI Router', w: '10W', t: '58 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847375392/washing_machine.png', title: 'Washer', w: '500W', t: '1.8 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847375591/tv.png', title: 'TV', w: '100W', t: '7.9 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839665411/Refrigerator.png', title: 'Refrigerator', w: '120W', t: '7 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847375782/kettle.png', title: 'Electric Kettle', w: '1500W', t: '0.5 hr' },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847375027/Blender.png', title: 'Baby food\nmaker', w: '300W', t: '3 hr' },
            ],
            info: {
                h: '3 Hr',
                list: [
                    { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847375209/router.png', title: 'WIFI router', w: '10W' },
                    { icon: 'https://websiteoss.ecoflow.com/upload/image/1736847375591/tv.png', title: 'TV', w: '60W' },
                    { icon: 'https://websiteoss.ecoflow.com/upload/image/1736839665411/Refrigerator.png', title: 'Refrigerator', w: '200W' },
                ],
            },
        },
    ];
    const [active, setActive] = useState(items[0]?.type);
    const currentActive = useMemo(() => items.find((item) => item.type === active) || items[0], [active, items]);

    return (
        <div className={`${css.thecomp}`} id="AU_4">
            <EfSpec />
            <img className="au4-icon" src="https://websiteoss.ecoflow.com/upload/image/1736839165507/au4-icon.svg" alt="" />
            <EfSection title={t('title')} desc={t('desc')} />
            <div className="content">
                <div className="info">
                    <div className="list">
                        {currentActive?.list?.map((i, idx) => (
                            <div className="list-item" key={idx}>
                                {typeof i.icon === 'string' ? <EfImg className="list-icon" pc={i.icon} /> : <div className="list-icon">{i.icon}</div>}
                                <span>
                                    <span>{i.title}</span>
                                    <br />
                                    <span>({i.w})</span>
                                    <br />
                                    <span>{i.t}</span>
                                </span>
                            </div>
                        ))}
                    </div>
                    {currentActive?.info && (
                        <div className="info-content">
                            <div className="info-title">Backup Time for Appliances</div>
                            <div className="info-list">
                                {currentActive.info?.list?.map((i, idx) => (
                                    <div className="info-list-item" key={idx}>
                                        <EfImg className="info-list-icon" pc={i.icon} />
                                        <span>
                                            <span>{i.title}</span>
                                            <br />
                                            <span>({i.w})</span>
                                        </span>
                                    </div>
                                ))}
                                <div className="info-list-title">{currentActive.info.h}</div>
                                <div className="info-list-desc">backup time</div>
                            </div>
                        </div>
                    )}
                </div>
                <EfImg className="content-img" pc={currentActive?.pc ?? ''} h5={currentActive?.h5} />
            </div>
            <EfTab
                items={items}
                activeType={active}
                onChange={(i) => {
                    if (i?.type) {
                        setActive(i.type);
                    }
                }}
            />
        </div>
    );
};

export default TheComp;
